<template>
  <!-- 안전 확인 -->
  <div class="widM pf23-inFo-safe-wrap pf23-lineBtm">
    <p class="fntP padTSM">안전 확인 <span class="ico-must-astar"></span></p>
    <p class="fntP padTSM ">‘안전확인동의서’ 에 ‘해당사항 있음’으로 체크한 항목이 있습니까? (임산부, 장애, 지병 및 기타 질병)</p>

    <div class="clearfix marTSM">
      
      <template v-for="(participant, idx) in mainResponses" >
        <div :key="`participant-safe-${idx}`"
        :class="{'floL pcOnly': idx==0, 'floR': idx != 0}"
        >
          <div class="pf23-inFo-safe">
        
            <div class="amway-theme" style="width:55%;">
              <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
                <label class="amw-radio-wrap radio-label focus">
                  <input
                    type="radio"
                    :id="`Q040-${idx}`"
                    :name="`safety-radio-${idx}`"
                    class="amw-global-radio"
                    value="Y"
                    @change="inputRadioAnswer(`${idx}`, 'Q040', 'Y')"
                    :checked="participant.questions['Q040'].raw_data === 'Y'"
                    :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable"
                  />
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">예</span>
                </label>
                <label class="amw-radio-wrap radio-label focus">
                  <input
                    type="radio"
                    :name="`safety-radio-${idx}`"
                    class="amw-global-radio"
                    value="N"
                    @change="inputRadioAnswer(`${idx}`, 'Q040', 'N')"
                    :checked="participant.questions['Q040'].raw_data === 'N'"
                    :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable"
                  />
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">아니오</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">* 해당 사항이 있는 경우 반드시 상세 내용을 동의서 상에 작성하여 주시기 바랍니다.</p>
  </div>
  <!-- //안전 확인 -->
</template>

<script>
import { mapGetters } from 'vuex'
import { CommonMethodMixin } from '../mixins'
import {
  SURVEY_SINGAPORE,
  SET_ATTENDANCE,
  CLEAR_RESPONSE_DATA,
  MAIN_RESPONSES,
} from '@/store/actions/survey'

export default {
  name: 'SurveyParticipant',
  mixins: [CommonMethodMixin],
  props: {
    infoAvailable: {
      type: Boolean,
      required: false
    },
  },
  computed: {
    ...mapGetters(SURVEY_SINGAPORE, {
      mainResponses: MAIN_RESPONSES,
    }),
  },
  methods: {
    selectAttendance(e) {
      const attendance_yn = e.target.value;
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_ATTENDANCE}`, { idx: this.seq, attendance_yn });
      if(attendance_yn === 'N') {
        this.$store.dispatch(`${SURVEY_SINGAPORE}/${CLEAR_RESPONSE_DATA}`, this.seq);
      }
    },
  },
}
</script>

<style>
.hilight>label {
  color: red !important;
  font-weight: bold !important;
}

.heigthMore { 
  min-height: 75px;
}
</style>


// WEBPACK FOOTER //
// src/views/surveys/singapore/components/SurveyParticipantSafe.vue